// extracted by mini-css-extract-plugin
export var active = "CircleMenu-module--active--d2b93";
export var centerCircle = "CircleMenu-module--centerCircle--a0d0f";
export var container = "CircleMenu-module--container--b61bb";
export var menu = "CircleMenu-module--menu--c732a";
export var polygonBox = "CircleMenu-module--polygonBox--d9972";
export var speechBabbleContent = "CircleMenu-module--speechBabbleContent--8b581";
export var toggle = "CircleMenu-module--toggle--ea365";